import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { ChipsContainer, freeBetStore, isMobile } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';
import { winningAmountStore } from '../../store/winningAmountStore';
import { betResponseCodeByName } from '../../enums/betResponseCode';
import { soundService, soundTypes } from '../../services/SoundService';
import { gameLiveConnection } from '../../services';

const ChipsWrapper = observer(() => {
  const {
    reBet,
    reBetAmount,
    quickBets,
    setDouble,
    setUndoBet,
    betsModels,
    selectedChip,
    setBetsModel,
    setSelectedChip,
    isFirstBetInRound,
    setIsFirstBetInRound,
    handleNotificationCode,
  } = doBetStore;
  const { isBetsClosed } = gameStore;
  const { setLastWin } = winningAmountStore;
  const { balance } = userInfoStore;
  const { activeFreeBet } = freeBetStore;

  const handleSelectChips = useCallback(
    (chip) => {
      setSelectedChip(chip);
    },
    [setSelectedChip]
  );

  const handleReBetOrDoubleBet = useCallback(() => {
    setLastWin(0);
    if (reBet && !betsModels.length) {
      if (reBetAmount > balance) {
        handleNotificationCode(betResponseCodeByName.NotEnoughBalance);
        return;
      }
      setBetsModel({ betModel: reBet });
      if (!isFirstBetInRound) {
        setIsFirstBetInRound(true);
        gameLiveConnection.handleDoChip();
      }
      soundService.play(soundTypes.chip);
    } else {
      setDouble();
    }
  }, [
    setLastWin,
    reBet,
    betsModels.length,
    reBetAmount,
    balance,
    setBetsModel,
    isFirstBetInRound,
    handleNotificationCode,
    setIsFirstBetInRound,
    setDouble,
  ]);

  if (isBetsClosed) {
    return null;
  }

  if (isMobile()) {
    return (
      <div className='m-bet-buttons-wr'>
        <button
          onClick={setUndoBet}
          className={`m-bet-button ${betsModels?.length ? '' : 'disabled'}`}
        >
          <i className='icon-undo' />
          <span className='m-bet-button-txt'>Undo</span>
        </button>
        <button
          onClick={handleReBetOrDoubleBet}
          className={`m-bet-button ${
            betsModels.length || (!betsModels.length && reBet) ? '' : 'disabled'
          }`}
        >
          <i className={`icon-${!betsModels.length && reBet ? 'rebet' : '2x'}`} />
          <span className='m-bet-button-txt'>
            {!betsModels.length && reBet ? 'REBET' : 'DOUBLE'}
          </span>
        </button>
      </div>
    );
  }

  return (
    <div className='bet-chips-container'>
      <div className={`bet-chips-column ${betsModels?.length ? '' : 'disabled'}`}>
        <button className='bet-chips-button' onClick={setUndoBet}>
          <i className='icon-undo bet-chips-button-icon' />
          <span className='bet-chips-button-text'>Undo</span>
        </button>
      </div>
      <ChipsContainer
        selectedChip={selectedChip}
        handleSelectChips={handleSelectChips}
        quickBets={quickBets}
        isFreeChip={!!activeFreeBet.id}
      />
      <div
        className={`bet-chips-column ${
          betsModels.length || (!betsModels.length && reBet) ? '' : 'disabled'
        }`}
      >
        <button className='bet-chips-button' onClick={handleReBetOrDoubleBet}>
          <i
            className={`icon-${!betsModels.length && reBet ? 'rebet' : '2x'} bet-chips-button-icon`}
          />
          <span className='bet-chips-button-text'>
            {!betsModels.length && reBet ? 'REBET' : 'DOUBLE'}
          </span>
        </button>
      </div>
    </div>
  );
});
export default ChipsWrapper;
